module.exports = __webpack_public_path__ + "static/img/award5_active.8ebdcfb.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/index/award5_active.png
// module id = ki7W
// module chunks = 7